<div class="pmt-wrap">
  <div class="pmt-head">
    <div>
      <h2 class="pmt-title">{{ 'myTeachers' | translate }}</h2>
      <p class="pmt-sub" *ngIf="studentName">{{ 'pmtSubtitle' | translate: { name: studentName, class: classLabel } }}</p>
    </div>
    <label class="pmt-search" *ngIf="teachers.length">
      <i class="ph ph-magnifying-glass"></i>
      <input type="text" [(ngModel)]="search" [placeholder]="'pmtSearchPlaceholder' | translate" />
    </label>
  </div>

  <div class="pmt-error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading; else pmtLoading">
    <div class="pmt-empty" *ngIf="(!teachers.length && !error) || (teachers.length && !hasMatches)">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>

    <!-- Class teacher -->
    <section class="pmt-class" *ngFor="let teacher of classTeachers; trackBy: trackByTeacherId">
      <div class="pmt-class-strip"><i class="ph ph-star"></i> {{ 'classTeacher' | translate }}</div>
      <div class="pmt-class-body">
        <button type="button" class="pmt-avatar pmt-avatar-lg" [class.clickable]="teacher.image" (click)="openPreview(teacher)"
          [style.color]="tone(teacher).color" [style.background]="tone(teacher).background">
          <img *ngIf="teacher.image" [src]="teacher.image" alt="{{ teacher.name }}" />
          <span *ngIf="!teacher.image">{{ initials(teacher.name) }}</span>
        </button>
        <div class="pmt-class-info">
          <span class="pmt-badge-mobile">{{ 'classTeacher' | translate }}</span>
          <div class="pmt-class-name">{{ teacher.name }}</div>
          <span class="pmt-pill" *ngIf="subjectsLabel(teacher)" [style.color]="tone(teacher).color" [style.background]="tone(teacher).background">{{ subjectsLabel(teacher) }}</span>
          <p class="pmt-class-note" *ngIf="studentName">{{ 'pmtClassTeacherNote' | translate: { name: studentName } }}</p>
        </div>
        <button type="button" class="pmt-msg-btn" (click)="openChat(teacher)">
          <i class="ph ph-chat-circle"></i><span>{{ 'message' | translate }}</span>
        </button>
      </div>
    </section>

    <!-- Subject teachers -->
    <ng-container *ngIf="subjectTeachers.length">
      <h3 class="pmt-section">{{ 'subjectTeachers' | translate }} <small>{{ 'pmtTeachersCount' | translate: { count: subjectTeacherCount } }}</small></h3>
      <div class="pmt-grid">
        <article class="pmt-card" *ngFor="let teacher of subjectTeachers; trackBy: trackByTeacherId">
          <div class="pmt-card-head">
            <button type="button" class="pmt-avatar" [class.clickable]="teacher.image" (click)="openPreview(teacher)"
              [style.color]="tone(teacher).color" [style.background]="tone(teacher).background">
              <img *ngIf="teacher.image" [src]="teacher.image" alt="{{ teacher.name }}" />
              <span *ngIf="!teacher.image">{{ initials(teacher.name) }}</span>
            </button>
            <div class="pmt-card-body">
              <div class="pmt-card-name">{{ teacher.name }}</div>
              <div class="pmt-card-subtitle">{{ 'pmtSubjectTeacher' | translate }}</div>
              <div class="pmt-card-subject-mobile" [style.color]="tone(teacher).color">{{ subjectsLabel(teacher) }}</div>
            </div>
            <button type="button" class="pmt-msg-icon" (click)="openChat(teacher)" [attr.aria-label]="'message' | translate">
              <i class="ph ph-chat-circle"></i>
            </button>
          </div>
          <span class="pmt-pill" *ngIf="subjectsLabel(teacher)" [style.color]="tone(teacher).color" [style.background]="tone(teacher).background">{{ subjectsLabel(teacher) }}</span>
          <button type="button" class="pmt-msg-outline" (click)="openChat(teacher)">
            <i class="ph ph-chat-circle"></i><span>{{ 'message' | translate }}</span>
          </button>
        </article>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #pmtLoading>
    <div class="pmt-grid">
      <div class="pmt-card pmt-card-skeleton" *ngFor="let n of [1,2,3,4]"></div>
    </div>
  </ng-template>
</div>

<!-- Full-screen photo preview — dismiss by tapping anywhere outside the photo -->
<div class="pmt-preview-overlay" *ngIf="previewTeacher as teacher" (click)="closePreview()">
  <div class="pmt-preview-box" (click)="$event.stopPropagation()">
    <button type="button" class="pmt-preview-close" (click)="closePreview()"><i class="ri-close-line"></i></button>
    <img class="pmt-preview-img" [src]="teacher.image" alt="{{ teacher.name }}" />
    <div class="pmt-preview-name">{{ teacher.name }}</div>
  </div>
</div>
